
















































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Webhook } from '@/api/model/webhook'
import { WebhookAPI } from '@/api/backend-client'
const smartMarketing = namespace('smartMarketing')

@Component
export default class CompanySettingsSmartMarketingWebhooks extends Vue {
    loadingWebhooks: boolean = false
    webhooks: Webhook[] = []

    mounted() {
        this.loadContent()
    }

    async loadContent(): Promise<void> {
        this.loadingWebhooks = true
        this.webhooks = await WebhookAPI.getAll()
        this.webhooks.sort((a, b) => a.name.localeCompare(b.name))
        this.loadingWebhooks = false
    }

    async copyWebhook(webhook: Webhook): Promise<void> {
        await navigator.clipboard.writeText(webhook.url)

        this.$notify({
            group: 'validation',
            text: this.$t('forms.edit_smart_marketing_form.copiedWebhookUrl').toString(),
        })
    }

    async createWebhook(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_webhook_create',
        })
    }

    async editWebhook(webhook: Webhook): Promise<void> {
        await this.$router.push({
            name: 'company_settings_webhook_edit',
            params: {
                id: webhook.id,
            },
        })
    }

    async deleteWebhook(webhook: Webhook): Promise<void> {
        if (confirm(`Weet je zeker dat je de webhook genaamd '${webhook.name}' wil verwijderen?`)) {
            this.loadingWebhooks = true
            await WebhookAPI.delete(webhook.id)
            await this.loadContent()
        }
    }
}
